import { CanActivateFn, Router, CanActivate } from '@angular/router'
import { inject } from '@angular/core'
import { WindowRef } from '../providers/WindowRef'
import { AuthService } from '../services/auth.service'

export const AuthGuard: CanActivateFn = async (route, state) => {
  const winRef = inject(WindowRef)
  const authService = inject(AuthService)
  const currPath = state.url.split('/')[2]
  const router = inject(Router)
  const promiseHasSession = await winRef.nativeWindow.gigya.hasSession()
  authService.setIsLogged(promiseHasSession)
  if (!promiseHasSession) {
    authService.setIsLogged(false)
    if (currPath == 'faq' || currPath == 'error') {
      return true
    } else router.navigate(['/login'])
  }

  return !!promiseHasSession
}
